import { baseApi } from "@/base"

type ContactPayload = {
  name: string
  email: string
  company: string | null
  message: string
  website: string | null
  t: number
}

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    submitContact: build.mutation<void, ContactPayload>({
      query: (body) => ({
        url: "contact",
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
    }),
  }),
})

export const { useSubmitContactMutation } = api
